import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Field, { fieldTypes } from "components/Field";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { changePassword } from "slices/app/actions/app";

const ChangePasswordModal = () => {
  const dispatch = useDispatch();

  const [oldPassword, setOldPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const isEnabled = () =>
    oldPassword &&
    newPassword &&
    confirmPassword &&
    oldPasswordError === "" &&
    newPasswordError === "" &&
    confirmPasswordError === "";

  const handleOk = () => {
    if (isEnabled()) {
      dispatch(changePassword(oldPassword, newPassword));
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.CHANGE_PASSWORD));
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter") {
      handleOk();
    }
  };

  return (
    <Modal
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header>
        <b>Change Password</b>
      </Modal.Header>
      <Modal.Body>
        <div className="change_password__modal">
          <Field
            type={fieldTypes.password}
            propsObject={{
              password: oldPassword,
              setPassword: setOldPassword,
              passwordError: oldPasswordError,
              setPasswordError: setOldPasswordError,
              labelText: "Old Password",
            }}
          />
          <Field
            type={fieldTypes.passwordAndConfirm}
            propsObject={{
              password: newPassword,
              setPassword: setNewPassword,
              passwordError: newPasswordError,
              setPasswordError: setNewPasswordError,
              confirmPassword,
              setConfirmPassword,
              confirmPasswordError,
              setConfirmPasswordError,
              passwordLabelText: "New Password",
              confirmLabelText: "Confirm New Password",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="saveButton"
          variant={buttonVariants.primary}
          onClick={handleOk}
          disabled={!isEnabled()}
          content="Ok"
        />
        <Button
          data-test="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
